import api from './api'

export const campaign = (params) => api.get('https://app-3qp0dwn1jo.marketingautomation.services/webforms/receivePostback/MzawMDU3MDQ0AgA/daac0fc8-00af-4784-8bea-218828e82f35/jsonp', {
    params,
})
